import axios from 'axios';
import {useState} from 'react';
import {useEffect, FC} from 'react';
// import {Swiper, SwiperSlide} from 'swiper/react';
import useEmblaCarousel from 'embla-carousel-react';

import {URLS} from '../../config';
import {hooks} from '../../hooks';
// import { utils } from '../../utils';
import {items} from '../../items';
import {custom} from '../../custom';
// import {theme} from '../../constants';
import {actions} from '../../store/actions';
import {components} from '../../components';
import {fetchCategories, fetchDisCounts} from '../../services/categoryService';
import {fetchCategoriesWithProducts} from '../../services/categoryService';
import {ProductType, BannerType, CategoryType} from '../../types';
// import { Categories } from './Categories';
// import Brocher_3 from '../../assets/images/Broucher_3.png';
// import {Box} from '@mui/material';
// import EmblaCarousel from '../../components/Carousel';
// import CarouselComponent from './Carousel';
import FloatingWhatsAppButton from '../../components/FloatingWhatsAppButton';

export const Home: FC = () => {
  const dispatch = hooks.useAppDispatch();
  const navigate = hooks.useAppNavigate();

  const [, emblaApi] = useEmblaCarousel();
  const [, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState<boolean>(true);

  const [, setBannersData] = useState<BannerType[]>([]);
  const [productsData, setProductsData] = useState<ProductType[]>([]);
  // const [carouselData, setCarouselData] = useState<CarouselType[]>([]);
  const [, setCategoriesData] = useState<CategoryType[]>([]);
  const [homeCategoriesData, setHomeCategoriesData] = useState<any[]>([]);
  const [discountProductData, setDiscountProductData] = useState<any[]>([]);
  const carouselData = [
    'https://www.guardianoffshore.com.au/wp-content/uploads/2015/03/banner-placeholder.jpg',
    // Brocher_3,
    // 'https://mariaandsons.com/img/cover/cover1.png',
    // 'https://mariaandsons.com/img/cover/cover2.png',
    // Add more image URLs as needed
  ];
  const handleSlideChange = () => {
    if (emblaApi) {
      setActiveIndex(emblaApi.selectedScrollSnap());
    }
  };

  const [, setCurrentIndex] = useState(0); // Active slide index
  // const emblaRefe = useRef(null); // Reference for the carousel container

  // Auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselData.length); // Cycle through images
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval); // Clean up the interval on unmount
  }, []);

  useEffect(() => {
    const fetchBestSellers = async () => {
      try {
        // Fetch categories and products data
        const data = await fetchCategoriesWithProducts();
        console.log(data);
        //  console.log(data.child);
        setHomeCategoriesData(data);
      } catch (error) {
        console.error('Failed to fetch best sellers:', error);
      }
    };
    const fetchDisCountsProducts = async () => {
      try {
        // Fetch categories and products data
        const data = await fetchDisCounts();

        setDiscountProductData(data);
      } catch (error) {
        console.error('Failed to fetch best sellers:', error);
      }
    };

    fetchBestSellers();
    fetchDisCountsProducts();
  }, []);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await fetchCategories();
        setCategoriesData(data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setLoading(false);
      }
    };

    loadCategories();
  }, []);
  useEffect(() => {
    updateProductImages();
    if (emblaApi) {
      emblaApi.on('select', handleSlideChange);
    }
  }, [emblaApi]);
  const updateProductImages = () => {
    const updatedProducts = productsData.map((product) => {
      return {
        ...product,
        image:
          'https://img.freepik.com/premium-photo/3d-render-photos-healthy-food-meal_1096167-99597.jpg?w=1380', // Update the image URL as needed
      };
    });

    setProductsData(updatedProducts);
  };
  const getData = async () => {
    setLoading(true);
    //  console.log(productsData);

    try {
      const products = await axios
        .get(URLS.GET_PRODUCTS)
        .then((res) => res.data.products);

      // const categories = await axios
      //   .get(URLS.GET_CATEGORIES)
      //   .then((res) => res.data.categories);

      const banners = await axios
        .get(URLS.GET_BANNERS)
        .then((res) => res.data.banners);

      // const carousel = await axios
      //   .get(URLS.GET_CAROUSEL)
      //   .then((res) => res.data.carousel);

      setBannersData(banners);
      setProductsData(products);
      // setCarouselData(carousel);
      // setCategoriesData(categories);
    } catch (error) {
      //      console.error(error);
    } finally {
    }
  };

  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, []);

  // const renderIndicator = (): JSX.Element => {
  //   return (
  //     <div
  //       style={{
  //         display: 'flex',
  //         justifyContent: 'center',
  //         position: 'absolute',
  //         bottom: 20,
  //         left: 20,
  //         flexDirection: 'row',
  //         gap: 6,
  //       }}
  //     >
  //       {carouselData?.map((imageSrc: string, index: number) => {
  //         const isSelected = index === activeIndex;
  //         return (
  //           <div
  //             style={{
  //               background: isSelected
  //                 ? theme.colors.mainColor
  //                 : theme.colors.white,
  //               width: 10,
  //               height: 10,
  //               borderRadius: 5,
  //             }}
  //             key={index}
  //           />
  //         );
  //       })}
  //     </div>
  //   );
  // };
  // const renderCarouselContent = (): JSX.Element => {
  //   return (
  //     <div className='embla' ref={emblaRef}>
  //       <div className='embla__container' style={{display: 'flex'}}>
  //         {carouselData.map((imageSrc: string, index: number) => {
  //           return (
  //             <div
  //               key={index}
  //               className='embla__slide'
  //               style={{
  //                 position: 'relative',
  //                 width: '100%',
  //                 flex: '0 0 100%',
  //                 overflow: 'hidden',
  //                 cursor: 'pointer',
  //               }}
  //             >
  //               <img
  //                 src={imageSrc}
  //                 style={{
  //                   width: '100%',
  //                   height: '50vh', // Adjusted to half the viewport height
  //                   objectFit: 'cover',
  //                 }}
  //                 onClick={() => {
  //                   navigate('/shop', {
  //                     state: {products: productsData, title: 'Shop'},
  //                   });
  //                 }}
  //               />
  //             </div>
  //           );
  //         })}
  //       </div>
  //     </div>
  //   );
  // };
  // const renderCarousel = () => {
  //   return (
  //     <section style={{position: 'relative', marginTop: 100, marginBottom: 20}}>
  //       {renderCarouselContent()}
  //       {renderIndicator()}
  //     </section>
  //   );
  // };

  const renderFooter = (): JSX.Element => {
    if (loading) return <components.TabLoader />;

    return (
      <components.Footer
        logo={true}
        copyright={true}
        links={[
          {label: 'Home', path: '/Home'},
          {label: 'About', path: '/About'},
          {label: 'Services', path: '/Services'},
          {label: 'Contact', path: '/Contact'},
        ]}
      />
    );
  };
  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        logo={true}
        burger={true}
        basket={true}
        line={true}
        navlink={true}
      />
    );
  };

  // const renderCategories = (): JSX.Element => {
  //   return (
  //     <div style={{marginBottom: 50}}>
  //       <Swiper
  //         spaceBetween={14}
  //         slidesPerView={'auto'}
  //         pagination={{clickable: true}}
  //       >
  //         {categoriesData.map((item: CategoryType) => {
  //           // console.log(item);
  //           return (
  //             <>
  //               <SwiperSlide
  //                 key={item.id}
  //                 style={{
  //                   height: 220,
  //                   width: 220,
  //                   borderRadius: 10,
  //                   cursor: 'pointer',
  //                   position: 'relative',
  //                   display: 'flex',
  //                   flexDirection: 'column',
  //                   padding: '10px 10px 8px 10px',
  //                   justifyContent: 'space-between',
  //                   backgroundColor: theme.colors.imageBackground,
  //                 }}
  //                 onClick={() => {
  //                   // Replace with your navigation logic
  //                   navigate('/shop', {
  //                     state: {products: item, title: 'Shop'}, // Adjust this as needed
  //                   });
  //                 }}
  //               >
  //                 <img
  //                   alt={item.name}
  //                   src={item.attachments?.category} // Ensure the API provides this image URL
  //                   style={{
  //                     objectFit: 'cover',
  //                     width: '100%',
  //                     height: '100%',
  //                     position: 'absolute',
  //                     inset: 0,
  //                     borderRadius: 10,
  //                     zIndex: -1,
  //                   }}
  //                 />

  //                 {/* Background gradient for better visibility */}
  //                 <div
  //                   style={{
  //                     position: 'absolute',
  //                     bottom: 0,
  //                     left: 0,
  //                     right: 0,
  //                     gap: 10,
  //                     height: '40%',
  //                     background:
  //                       'linear-gradient(transparent, rgba(0, 0, 0, 0.5))',
  //                     borderRadius: '0 0 10px 10px',
  //                     zIndex: 0,
  //                   }}
  //                 />

  //                 <span
  //                   style={{
  //                     ...theme.fonts.DM_Sans_400Regular,
  //                     fontSize: 8,
  //                     backgroundColor: theme.colors.pastelMint,
  //                     alignSelf: 'flex-start',
  //                     padding: '2px 3px 1px 3px',
  //                     borderRadius: 50,
  //                     lineHeight: 1.5,
  //                   }}
  //                 >
  //                   {item.qty} {/* Adjust the qty field to match your API */}
  //                 </span>

  //                 <Box
  //                   component='span'
  //                   sx={{
  //                     ...theme.fonts.DM_Sans_400Regular,
  //                     fontSize: 14,
  //                     fontWeight: 600,
  //                     color: theme.colors.white,
  //                     lineHeight: 1.5,
  //                     display: '-webkit-box',
  //                     WebkitBoxOrient: 'vertical',
  //                     WebkitLineClamp: 1,
  //                     overflow: 'hidden',
  //                     textOverflow: 'ellipsis',
  //                     whiteSpace: 'nowrap',
  //                     zIndex: 1,
  //                     textShadow: '1px 1px 4px rgba(0, 0, 0, 0.7)',
  //                     transition: 'color 0.3s',
  //                     '&:hover': {
  //                       color: theme.colors.mainYellow, // Hover color here
  //                     },
  //                   }}
  //                 >
  //                   {item.name}
  //                 </Box>
  //               </SwiperSlide>
  //             </>
  //           );
  //         })}
  //       </Swiper>
  //     </div>
  //   );
  // };

  const renderBestSellers = (): JSX.Element => {
    return (
      <div style={{marginBottom: 30}}>
        {homeCategoriesData.map((category: any, index: number) => (
          <div key={category.id} style={{flexDirection: 'column'}}>
            <components.BlockHeading
              title={category.name}
              titleStyle={{fontWeight: 'bold'}}
              containerStyle={{
                padding: '10px 20px',
                marginBottom: 20,
                marginTop: 20,
                paddingTop: 40,
                backgroundColor: '#f9f9f9',
              }}
              viewAllOnClick={() => {
                dispatch(actions.resetFilters());
                navigate('/ShopHome', {
                  state: {CategoryId: category.id, title: category.name},
                });
              }}
            />

            <custom.ScrollView style={{paddingLeft: 20, paddingRight: 20}}>
              {category.products?.map(
                (product: ProductType, index: number, arra: ProductType[]) => {
                  const isLast = index === arra.length - 1;
                  return (
                    <items.CaregoryProductCard
                      key={product.id}
                      isLast={isLast}
                      item={product}
                      version={1}
                    />
                  );
                }
              )}
            </custom.ScrollView>
            {/* {(index + 1) % 5 === 0 && renderBanner()} */}
          </div>
        ))}
      </div>
    );
  };
  const renderDiscount = (): JSX.Element => {
    return (
      <div
        style={{
          paddingBottom: 20,
          paddingTop: 30,
          borderRadius: 10,
          margin: '0 10px',
        }}
      >
        <components.BlockHeading
          viewAllVisible={false}
          title={'🔥 Discount Deals'}
          titleStyle={{
            fontWeight: 'bold',
            color: '#D7263D',
            fontSize: 24,
            // textDecoration: 'underline',
            // textDecorationColor: '#D7263D',
            // textUnderlineOffset: 6,
            // textDecorationThickness: 1,
          }}
          containerStyle={{
            borderColor: '#E7EBEB',
            borderRightWidth: 0,
            borderTopLeftRadius: 10,
            borderBottomLeftRadius: 10,
            marginBottom: 14,
            paddingTop: 20,
            paddingBottom: 20,
            marginLeft: 0,
          }}
        />
        <custom.ScrollView style={{paddingLeft: 20, paddingRight: 20}}>
          {discountProductData?.map(
            (product: ProductType, index: number, arra: ProductType[]) => {
              const isLast = index === arra.length - 1;
              return (
                <items.CaregoryProductCard
                  key={product.id}
                  isLast={isLast}
                  item={{...product}}
                  version={1}
                  isDiscount={true}
                />
              );
            }
          )}
        </custom.ScrollView>
      </div>
    );
  };

  // const renderBanner = (): JSX.Element => {
  //   return (
  //     <div style={{margin: '0 20px 40px 0'}}>
  //       <button
  //         onClick={() => {
  //           dispatch(actions.resetFilters());
  //           navigate('/Shop', {state: {products: productsData}});
  //         }}
  //         style={{width: '100%'}}
  //       >
  //         <img
  //           src={'https://mariaandsons.com/img/cover/cover2.png'}
  //           alt='Banner'
  //           style={{
  //             objectFit: 'cover',
  //             width: '100%',
  //             height: '50vh', // Reduce the height to half
  //             borderTopRightRadius: 5,
  //             borderBottomRightRadius: 5,
  //           }}
  //         />
  //       </button>
  //     </div>
  //   );
  // };

  // const renderFeatured = (): JSX.Element => {
  //   return (
  //     <div style={{marginBottom: 40, display: 'flex', flexDirection: 'column'}}>
  //       <components.BlockHeading
  //         title='Featured products'
  //         containerStyle={{paddingLeft: 20, paddingRight: 20, marginBottom: 14}}
  //         viewAllOnClick={() => {
  //           dispatch(actions.resetFilters());
  //           navigate('/Shop', {
  //             state: {products: productsData, title: 'Featured'},
  //           });
  //         }}
  //       />
  //       <custom.ScrollView style={{paddingLeft: 20, paddingRight: 20}}>
  //         {productsData?.map(
  //           (item: ProductType, index: number, arra: ProductType[]) => {
  //             const isLast = index === arra.length - 1;
  //             return (
  //               <items.ProductCard
  //                 key={item.id}
  //                 isLast={isLast}
  //                 item={item}
  //                 version={1}
  //               />
  //             );
  //           }
  //         )}
  //       </custom.ScrollView>
  //     </div>
  //   );
  // };

  const renderContent = () => {
    if (loading) return <components.TabLoader />;

    return (
      <main
        style={{
          paddingBottom: 64,
          maxWidth: '1440px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          marginTop: 162,
        }}
      >
        {/* {renderCarousel()} */}
        <div style={{height: '10px'}}></div>
        {/* {renderCategories()} */}
        {discountProductData &&
          discountProductData.length > 0 &&
          renderDiscount()}
        {renderBestSellers()}
        {/* {renderBestSellers()} */}
        {/* {renderBanner()} */}
      </main>
    );
  };

  // const renderBottomTabBar = () => {
  //   return <components.BottomTabBar />;
  // };

  // const renderBanner2 = () => {
  //   return (
  //     <Box
  //       style={{
  //         width: '100vw',
  //         height: '230px',
  //         backgroundColor: '#015840',
  //         display: 'flex',
  //         alignItems: 'center',
  //         justifyContent: 'center',
  //         fontSize: '28px',
  //         color: '#FFFFFF',
  //         fontWeight: '600',
  //         marginTop: 200,
  //       }}
  //     >
  //       <div
  //         style={{
  //           maxWidth: '1280px',
  //           textAlign: 'center',
  //           display: 'flex',
  //           alignItems: 'center',
  //           justifyContent: 'space-between',
  //           gap: 30,
  //           width: '100%', // Ensure it takes full width
  //         }}
  //       >
  //         <div style={{flex: '1', textAlign: 'left', margin: '0'}}>
  //           <h1 style={{margin: '0'}}>
  //             Convenient Pickup or Delivery—Your Choice!
  //           </h1>
  //         </div>
  //         <div style={{flex: '2', margin: '0'}}>
  //           <CarouselComponent />
  //         </div>
  //       </div>
  //     </Box>
  //   );
  // };

  return (
    <div>
      {renderHeader()}
      {/* {renderBanner2()} */}

      {renderContent()}
      {renderFooter()}

      {/* {renderBottomTabBar()} */}
      <FloatingWhatsAppButton />
    </div>
  );
};
